import type {FC} from 'react';
import {memo} from 'react';

import TopMenu from './../../modules/TopMenu/TopMenu';

interface Props {
  isWithCrumbs?: boolean;
  isWithFrom?: boolean;
  skipRootCrumb?: boolean;
}

const TopMenuLayout: FC<Props> = ({
  isWithCrumbs,
  isWithFrom,
  skipRootCrumb,
}) => {
  return (
    <div className="TopMenuLayout">
      <TopMenu
        isWithCrumbs={isWithCrumbs}
        isWithFrom={isWithFrom}
        skipRootCrumb={skipRootCrumb}
      />
    </div>
  );
};

export default memo(TopMenuLayout);
